import "@/pages/CaseDetail/Summary/summary.scss";
import { IconoirArrowLeft } from "@ey-xd/motif-icon";
import Breadcrumb from "@/components/Breadcrumb/Breadcrumb";
import { MotifIcon } from "@ey-xd/motif-react";
import "./SummaryForm/SummaryForm.scss";
import DefinedTabPanel from "@/components/TabPanel/DefinedTabPanel";
import { GridBanner } from "@/components/GridBanner/GridBanner";
import { useLocation, useNavigate } from "react-router-dom";
import NotificationGrid from "@/components/Notification/NotificationGrid";
// import { Create_SUCCESSFUL, UPDATE_SUCCESSFUL } from "@/Constant";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CaseContext from "../CaseContext";
import ConfirmationModal from "@/components/Modal/ConfirmationModal/ConfirmationModal";
import { useSelector } from "react-redux";

export default function Summary() {
  const { t }=useTranslation();
  let location = useLocation();
  const navigate = useNavigate();
  let state = location.state;
  if (!state) {
    state = { showMessage: false, defaultActiveKey: 0, update: false };
  }
  const [editCase,setEditCase]=useState(false);

 const [showDiscardPopup, setShowDiscardPopup] = useState(false);
  let discardDetails = useSelector((e: any) => e.discardChangesDatas.data);

  function handleClose() {
    setEditCase(false);
    setShowDiscardPopup(false);
  }
  function handleReject() {
    setShowDiscardPopup(false);
  }
  useEffect(() => {
    if (state.showMessage) {
      setTimeout(() => {
        navigate(location, { ...state, showMessage: false });
      }, 5000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  const searchParams = new URLSearchParams(window.location.search);
  let activeTab = searchParams.get("activeTab");
  if (activeTab) {
    state.defaultActiveKey = parseInt(activeTab);
  }

let caseContextData = {
  editCase: editCase,
  setEditCase: (flag: boolean) => {
    setEditCase(flag);
  },
};
  const breadcrumbItems = [
    {
      text: t("global.globalActions.backToHome"),
      url: "/",
      icon: <MotifIcon src={IconoirArrowLeft} />,
      blockNavigation:editCase
    },
  ];

  return (
    <div>
      <div onClick={() =>{
        if (discardDetails.editMode) {
          setShowDiscardPopup(true);
        } else {
          setEditCase(false);
        }
      }}>
      <Breadcrumb items={breadcrumbItems} ariaLabel="Breadcrumb navigation" />
      </div>
      <GridBanner />
      {state.showMessage && (
        <NotificationGrid
          show={state.showMessage}
          message={
            state.update
              ? "global.globalNotifications.updatedSuccessfully"
              : "global.globalNotifications.createdSuccessfully"
          }
          type="success"
        />
      )}
        <CaseContext.Provider value={caseContextData} >
      <DefinedTabPanel  defaultActiveKey={state.defaultActiveKey} />
      </CaseContext.Provider>
      <ConfirmationModal
              isVisible={showDiscardPopup}
              setIsVisible={handleClose}
              cancelBtnApproveHandler={handleClose}
              cancelBtnRejectHandler={handleReject}
            />
    </div>
  );
}
